import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import App from "../App"
import Schedule from "../pages/schedule/schedule.jsx"
import Login from "../pages/login.jsx"
import CreateInvoice from "../pages/invoice/createInvoice.jsx"
import PriceList from "../pages/priceList.jsx"
import Invoice from "../pages/invoice/invoice.jsx"
import Finance from "../pages/finance/finance.jsx"
import InvoicePreview from "../pages/invoice/invoicePreview.jsx"
import FeeCO from "../pages/finance/feeCO.jsx"

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route element={<App/>} path="/">
                    <Route element={<PriceList />}  path="/price-list"/>
                    <Route element={<Invoice />}  path="/invoice"/>
                    <Route element={<InvoicePreview />}  path="/invoice/:id"/>
                    <Route element={<CreateInvoice />}  path="invoice-create"/>
                    <Route element={<Schedule />}  path="/schedule"/>
                    <Route element={<Finance />}  path="/accounting">
                        <Route element={<FeeCO />} path="fee-co"/>
                    </Route>
                </Route>
                <Route element={<Login />} path="/login"/>
            </Routes>
        </Router>
    )
}

export default AppRouter